<script>
  import * as turf from "@turf/turf";
  import mapboxgl from "mapbox-gl";
  import { onMount } from "svelte";
  import { tooltip } from "@svelte-plugins/tooltips";
  import {
    isCalculate,
    drawClicked,
    bufferZoneValue,
    bufferLocationValue,
    pointClicked,
    InsightsRadioCheck,
    lpCoords,
    drawingMode,
  } from "../../../store.js";

  import CalculateLocationZonePotential from "./CalculateLocationZonePotential.svelte";
  import App from "../../../App.svelte";
  export let map;
  let coords;
  let marker;
  let coordinates;
  let bufferLocation = 2;
  $: $bufferLocationValue = bufferLocation;

  function onMapClick(event) {
    coordinates = event.lngLat;

    if (document.getElementsByClassName("mapboxgl-marker").length > 0) {
      alert("Only one location allowed at a time, please reset");
      map.off("click", onMapClick);
    } else {
      $lpCoords = [coordinates.lng, coordinates.lat];

      marker = new mapboxgl.Marker({ color: "#D9484D" })
        .setLngLat([coordinates.lng, coordinates.lat])
        .addTo(map);
      map.off("click", onMapClick);
    }
  }
  function drawPoint() {
    $drawingMode = false;
    map.getCanvas().style.cursor = "pointer";
    if ($InsightsRadioCheck == "LP") {
      map.on("click", onMapClick);
    } else {
      map.off("click", onMapClick);
    }
  }
  function clearPoint() {
    if (document.getElementsByClassName("mapboxgl-marker").length > 0) {
      [...document.getElementsByClassName("mapboxgl-marker")].forEach((d) => {
        d.remove();
      });
    }
    if (map.getSource("buffer")) {
      map.removeLayer("buffer");
      map.removeSource("buffer");
    }

    $pointClicked = false;
  }
</script>

<div class="schemePotential">
  <h4 style="color:white;margin:15px;font-weight:500">Location Zone:</h4>
  <CalculateLocationZonePotential {map} {coords} {bufferLocation} />
  <div
    class="slidecontainer"
    style="position:relative;left: 18px;font-size:12px"
  >
    <p>
      Select your location:<span
        style="    text-align: justify;
    right: 45px;
    top: -7px;
    font-weight: 600;
    font-size: 22px;
    color: #D9484D;
    position: absolute;"
      ></span>
    </p>

    <button class="drawPoint" on:click={drawPoint}>Select Point</button>
    <button class="drawPoint" on:click={clearPoint}
      ><i class="fa-solid fa-trash"></i></button
    >
  </div>
  <div
    class="slidecontainer"
    style="position:relative;left: 18px;font-size:12px"
  >
    <p>
      <span
        use:tooltip={{
          content:
            "<span style='font-size:11px'> Please choose the average journey length you would like to allow for in your local area</span>",
          position: "top",
          autoPosition: true,
          style: {
            backgroundColor: "gray",
          },
          maxWidth: 150,
        }}
        style="position: relative;
        z-index: 100000"
      >
        Select travel zone size
      </span><span
        style="text-align: justify;
    right: 25px;
    top: -7px;
    font-weight: 600;
    font-size: 22px;
    color: #D9484D;
    position: absolute;"
        >{bufferLocation}
        <span style="font-weight: 400;font-size:16px">km</span></span
      >
    </p>

    <input
      style="margin-top: -10px;width:80%;padding:0px;accent-color:#D9484D"
      type="range"
      step=".5"
      min="2"
      max="10"
      bind:value={bufferLocation}
    />
  </div>
</div>

<style>
  .drawPoint {
    border-radius: 5px;
    left: 20%;
    position: relative;
  }
</style>
